import { React, PropTypes, reduxConnect } from '../lib/imports';

import TimsFooter from '../common/Footer';
import { useCdnUrl } from './context/config';

const Footer = ({ termsText }) => <TimsFooter cdnUrl={useCdnUrl()} content={termsText} />;

Footer.propTypes = {
  termsText: PropTypes.string,
};

const mapStateToProps = (state) => {
  const { leaderboard, strings } = state;
  const { currentChallenge, isCurrentlyPlayoffs } = leaderboard;

  const legalTextKey = isCurrentlyPlayoffs ? 'global/legalTextPlayoffs' : 'global/legalText';

  return {
    termsText: strings && currentChallenge && strings[legalTextKey],
  };
};

export default reduxConnect(mapStateToProps)(Footer);
